/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_Source_Event_GroupInputs */

const en_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading source Event Group for translation`)
};

const fr_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversement du groupe d’événements source pour la traduction`)
};

const de_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochladen der Quellereignisgruppe zur Übersetzung`)
};

const it_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del gruppo di eventi sorgente per la traduzione`)
};

const ru_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка исходной группы событий для перевода.`)
};

const es_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando el grupo de eventos de origen para su traducción`)
};

const zh_cn2_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传源事件组进行翻译`)
};

const ja_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳用のソースイベントグループをアップロードしています`)
};

const hi_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद के लिए स्रोत इवेंट समूह अपलोड किया जा रहा है`)
};

const pt_pt2_uploading_source_event_group = /** @type {(inputs: Uploading_Source_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o grupo de eventos de origem para tradução.`)
};

/**
* | output |
* | --- |
* | "Uploading source Event Group for translation" |
*
* @param {Uploading_Source_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_source_event_group = /** @type {((inputs?: Uploading_Source_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_Source_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_uploading_source_event_group(inputs)
	if (locale === "de") return de_uploading_source_event_group(inputs)
	if (locale === "it") return it_uploading_source_event_group(inputs)
	if (locale === "ru") return ru_uploading_source_event_group(inputs)
	if (locale === "es") return es_uploading_source_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_uploading_source_event_group(inputs)
	if (locale === "ja") return ja_uploading_source_event_group(inputs)
	if (locale === "hi") return hi_uploading_source_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_uploading_source_event_group(inputs)
	return en_uploading_source_event_group(inputs)
});